import { SxProps } from '@mui/material';

export const sxAnexosTableContainer: SxProps = {
  borderRadius: '10px',
  width: '100%',
};

export const sxAnexosTableCell: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontSize: '14px',
  fontWeight: 400,
  border: 'none',
  backgroundColor: 'inherit',
};

export const sxAnexosTableHeaderCell: SxProps = {
  ...sxAnexosTableCell,
  backgroundColor: '#F9F9F9',
};

export const sxAnexosTableRow: SxProps = {
  '&:nth-of-type(even)': {
    backgroundColor: '#F9F9F9',
    border: 'none',
  },
};

export const sxAnexosExcluirButton: SxProps = {
  minWidth: 'unset',
  padding: '4px',
  color: '#CC3D3D',
  '&:hover': {
    backgroundColor: 'transparent',
    color: '#A32F2F',
  },
};

export const sxAnexosCardExcluirButton: SxProps = {
  borderRadius: '80px',
  padding: '12px 32px',
  width: '100%',
  minWidth: 'min-content',
  justifyContent: 'center',
  gap: '8px',
  border: '2px solid #00995d',
  color: '#00995d',
  backgroundColor: '#fff',
  '&:hover': {
    backgroundColor: 'rgba(0, 153, 93, 0.06)',
    border: '2px solid #00995d',
  },
  '& .MuiButton-endIcon': {
    marginLeft: '8px',
    marginRight: 0,
  },
};

export const sxCameraCaptureModal: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '480px',
  width: '90%',
  bgcolor: '#fff',
  borderRadius: '16px',
  border: 'none',
  boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
  padding: '24px',
  maxHeight: '100vh',
  overflow: 'auto',
  outline: 'none',
};
